import PageWrapper from '../../components/PageWrapper'
import Tab from '../../components/Tab/Tab'
import EstateIcon from '../../assets/icons/HouseIcon'
import { useEffect, useState } from 'react'
import EditIcon from '../../assets/icons/Edit'
import ButtonTab from '../../components/Tab/ButtonTab'
import { useLocation, useNavigate } from 'react-router-dom'

const EditEstates = () => {
  const [currentView, setCurrentView] = useState('')
  const location = useLocation()
  const [, setNumOfResidentTypes] = useState(0)

  const isActiveView = (view: string) => {
    return view === currentView
  }

  const navigate = useNavigate()

  const handleViewSelect = (view: string, queries?: Record<string, string>) => {
    if (isActiveView(view)) {
      return
    }
    let queryArr = [`active=${view}`]
    for (let key in queries) {
      queryArr.push(`${key}=${queries[key]}`)
    }
    window.history.replaceState(null, '', `?${queryArr.join('&')}`)
    setCurrentView(view)
  }

  useEffect(() => {
    const path = location.pathname
    if (path.includes('edit')) {
      setCurrentView('edit')
    }
  }, [location.pathname])

  return (
    <PageWrapper title="My Estates" description="Here are the Estates you belong to.">
      <div className="flex gap-10">
        <Tab
          text={'My Estates'}
          Icon={EstateIcon}
          active={isActiveView('my estate')}
          onClick={() => navigate('/estates')}
        />
        <Tab
          text={'Edit Estate'}
          Icon={EditIcon}
          active={isActiveView('edit')}
          onClick={() => handleViewSelect('edit')}
        />
      </div>

      <ButtonTab setNumOfResidentTypes={setNumOfResidentTypes} />
    </PageWrapper>
  )
}

export default EditEstates
